import React from "react"
import PropTypes from "prop-types"
import { Provider } from "react-redux"
import createStore from "../../state/createStore"
import $ from "jquery"
import ContentPage from "../../components/content-page"
import Meta from "../../components/meta"
import "animate.css/animate.min.css"
import Herosection from '../../components/heroSection'
import About from '../../components/about'
import Advisors from '../../components/advisors'
import Program from '../../components/program'
import Knowledgecenter, { knowledgecenter } from '../../components/knowledgeCenter'

const store = createStore()

export class Home extends React.Component {
	constructor (args) {
		super(args)
		this.state = {
			isShowSidebar: false,
			isAboutActive: false,
			activeRouteName: "",
			appLoader: false
		}
	}
	componentDidMount () {
		// ReactPixel.init("2879175222167037")
		// ReactPixel.track("ViewContent", location)
		// $(document).ready(function(){
		// 	$('.parallax').parallax();
		// });
		// this.setState({
		// 	isAboutActive: true
		// })
		const { setFunc } = this
		const { isAboutActive } = this.state
		let hash = window.location.hash
		// console.log("hash", hash)
		// $(document).ready(function () {
		//     // Handler for .ready() called.
		//     $('html, body').animate({
		//         scrollTop: $(hash).offset().top
		//     }, '2000');
		// });
		// let hash = window.location.hash
		if (hash) {
			// window.scrollTo(0, this.refs[hash].offsetTop)
		}
		// if (hash !== "" ) {
		// 	window.scrollTo(0, $(hash).offset().top)
		// 	// $('html, body').animate({
		//  //        scrollTop: $(hash).offset().top
		//  //    }, 2000);
		// }
		// // console.log("isAboutActive", isAboutActive)
		$(window).scroll(function () {
			// let scrollPos = $(document).scrollTop()
			// $(".right__to__logo .anchor__text").each(function () {
			// 	let currLink = $(this)
			// 	let refElement = $(currLink.attr("href"))
			// 	console.log("currLink", refElement, currLink)
			// 	if (refElement.position().top - 140 <= scrollPos && refElement.position().top + refElement.height() > scrollPos) {
			// 		$("#navBar div span a").removeClass("active")
			// 		currLink.addClass("active")
			// 	} else {
			// 		currLink.removeClass("active")
			// 	}
			// })
			// $(".section").each(function () {
			// 	var cutoff = $(window).scrollTop()
			// 	if ($(this).offset().top + $(this).height() > cutoff && $(this)[0].id === "about" && !isAboutActive) {
			// 		if (!isAboutActive) {
			// 			// // console.log("isAboutActive", isAboutActive)
			// 			setFunc()
			// 		}
			// 		return false // stops the iteration after the first one on screen
			// 	}
			// })
		})
		// this.setState({
		// 	appLoader: false
		// })
	}
	setFunc = () => {
		// // console.log("setFunc", this.state.isAboutActive)
		if (!this.state.isAboutActive) {
			this.setState({
				isAboutActive: true
			})
		}
	}
	handleScroll = (item) => {
	}
	getActiveRoute = (name) => {
		this.setState({
			activeRouteName: name
		})
	}
	render () {
		const { location } = this.props
		return (<Provider store={store}>
			<ContentPage>
				<Meta title="Winpe ProClub Mentorship Program " description="A pioneering initiative that aims to accelerate career growth for high performing women from the investing ecosystem by connecting them with industry leaders for 1:1 mentoring." image={"https://winpeforum.com/assets/elements/winpe_proclub_updated_linkimage1.jpg"} location={location} />
				<div className="page-layout__viewport">
					<div className="page-layout__viewport__left_content"></div>
					<div className="page-layout__viewport__middle_content">
						<div id="fullscreen" className="fullscreen">
							<div id="#" className="section main__wrapper">
								<Herosection />
							</div>
							<div ref="#about" id="about" className="section main__wrapper">
								<About />
							</div>
							{/*<div id="launch" className="section main__wrapper">
															<Program />
														</div> */}
							<div ref="#advisors" id="advisors" className="section main__wrapper">
								<Advisors />
							</div>
							{/*<div id="#" className="section main__wrapper">
															<Knowledgecenter />
														</div> */}
						</div>
							{/* appChildren */}
					</div>
				</div>
			</ContentPage>
		</Provider>
		)
	}
}

Home.propTypes = {
	location: PropTypes.object
}
export default Home



// WEBPACK FOOTER //
// ./src/pages/home/index.js